import React from "react";
import { seoDefaults } from "../utils/seoDefaults";
import SEO from "../api/seo";

const AboutUs = () => {
  const reviews = [
    {
      name: "Richie",
      comment: "Amazing ambience. Feels like a gaming cafe. Really good PC ,with an Xbox, ps5 and The rates are affordable. The people running it are very welcoming, cool, and kind as well. Had great time here and will visit again❤️✨",
    },
    {
      name: "Moses",
      comment: "The gaming session was straight-up 10/10, no cap. Everything was on point, and the staff treated us so well. Went with frnds, and we had a blast. Definitely gonna make it a regular thing from now on. Super stoked for the next time! 🎮👾",
    },
    {
      name: "Vickie K",
      comment: "Stable internet connection and peaceful gaming experience.Owner is very friendly towards the customers.New games and collections are added every day and your choices for games are also considered by the owner. So a must try spot to all gamers in tirunelveli.",
    },
    {
      name: "Arafathali M",
      comment: "The Gamestick M22 is a budget-friendly retro console with 30,000+ preloaded games. It’s plug-and-play via HDMI and includes two wireless controllers. However, support from the game studio is helpful, and also supports firmware game updates and controller fixes.",
    },
  ];

  return (
    <>
     <SEO {...seoDefaults.about} />
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-black to-gray-900 text-white p-8 pt-24">
      <div className="max-w-6xl mx-auto bg-gray-900/70 backdrop-blur-lg border border-purple-700 rounded-2xl shadow-2xl p-10 mt-16">
        <h1 className="text-5xl font-extrabold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600  hover:from-purple-600 hover:to-cyan-400">
          About Us
        </h1>
        <p className="text-lg text-gray-300 mb-6 text-center max-w-3xl mx-auto">
          Welcome to <span className="font-bold text-white">Game Ztudio</span>, your ultimate destination for premium gaming gear, consoles, and collectibles. We're here to fuel your passion for gaming with the best products and an unforgettable shopping experience.
        </p>

        <div className="grid md:grid-cols-2 gap-8 mt-10">
          <div className="bg-gray-800/70 p-6 rounded-2xl border border-purple-600 shadow-lg">
            <h2 className="text-2xl font-bold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              Our Mission
            </h2>
            <p className="text-gray-300 text-base leading-relaxed">
              We aim to create an immersive, next-level gaming experience by offering state-of-the-art products, exclusive editions, and top-notch customer service. Every gamer deserves the best, and we’re here to deliver just that.
            </p>
          </div>

          <div className="bg-gray-800/70 p-6 rounded-2xl border border-purple-600 shadow-lg">
            <h2 className="text-2xl font-bold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-yellow-500">
              What We Offer
            </h2>
            <ul className="list-disc pl-5 text-gray-300 space-y-2">
              <li>🔥 Latest PlayStations & Xbox consoles</li>
              <li>🎮 High-quality controllers, headsets, and gaming chairs</li>
              <li>💿 Rare and exclusive game CDs & collectibles</li>
              <li>🚀 Fast shipping & secure packaging</li>
              <li>🛡️ Hassle-free returns & support</li>
            </ul>
          </div>
        </div>

        <div className="mt-12">
          <h2 className="text-3xl font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-teal-500 text-center">
            Our Story
          </h2>
          <p className="text-gray-300 text-lg leading-relaxed max-w-4xl mx-auto text-center">
            Born from a deep love for gaming, <span className="font-bold text-white">Game Ztudio</span> was created to be more than just a store—it’s a community for gamers by gamers. We understand the thrill of unboxing a new console, the excitement of getting your hands on the latest releases, and the nostalgia of classic titles. Our team is passionate about bringing the best of gaming to every doorstep.
          </p>
        </div>

        <div className="mt-16">
          <h2 className="text-3xl font-extrabold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-500 text-center">
            What Our Customers Say
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {reviews.map((review, index) => (
              <div
                key={index}
                className="bg-gray-800/70 p-6 rounded-2xl border border-pink-600 shadow-lg transform hover:scale-105 transition duration-300"
              >
                <p className="text-gray-300 italic mb-4">“{review.comment}”</p>
                <p className="font-bold text-white">— {review.name}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <h3 className="text-3xl font-extrabold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-500">
            Ready to Power Up?
          </h3>
          <p className="text-gray-400 max-w-2xl mx-auto mb-6">
            Dive into a world of epic games, cutting-edge consoles, and gear that takes your play to the next level. Let's make every game legendary.
          </p>
          <button className="px-8 py-3 rounded-2xl text-lg font-semibold bg-gradient-to-r from-cyan-400 to-purple-600  hover:from-purple-600 hover:to-cyan-400 shadow-lg transform hover:scale-105 transition">
            Explore Our Store
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default AboutUs;
